<template>
  <div>
    <div class="web3">
      <div class="outterBox">
        <div class="topHeader">
          <span> 운영코스 </span>
          <span class="headerDetailText"> 선택한 일자에 운영되는 코스 </span>
        </div>
        <div class="top">
          <div class="dateColumn">
            {{ courseString }}
            <!--        <div v-for="i in courseList" :key="i.detail">-->
            <!--          <article class="feature1">-->
            <!--            <input type="radio" id="feature1" :value="i" v-model="selectedCourse" :disabled="listType !== 'REAL'" />-->
            <!--            <div>-->
            <!--          <span>-->
            <!--            {{ i.coseName }}-->
            <!--          </span>-->
            <!--            </div>-->
            <!--          </article>-->
            <!--        </div>-->
          </div>
        </div>
      </div>
    </div>
    <div class="mobile3">
      <div class="outterBox">
        <div class="topHeader">
          <span> 운영코스 </span>
          <span class="subinfo"> 선택한 일자에 운영 가능한 코스입니다. </span>
        </div>
        <div class="top">
          <div class="dateColumn">
            {{ courseString }}
            <!--        <div v-for="i in courseList" :key="i.detail">-->
            <!--          <article class="feature1">-->
            <!--            <input type="radio" id="feature1" :value="i" v-model="selectedCourse" :disabled="listType !== 'REAL'" />-->
            <!--            <div>-->
            <!--          <span>-->
            <!--            {{ i.coseName }}-->
            <!--          </span>-->
            <!--            </div>-->
            <!--          </article>-->
            <!--        </div>-->
          </div>
        </div>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import reserveService from '@/services/rev.service';
import GeneralUtil from '@/util/GeneralUtil';

export default {
  name: 'CoursePicker',
  components: {},
  mixins: [GeneralUtil],
  props: {
    listType: String,
    revConfirmList: Array,
  },
  data() {
    return {
      selectedDate: null,
      selectedCourse: null,
      courseList: [],
    };
  },
  computed: {
    courseString() {
      let result = '';
      this.courseList.forEach((c, index) => {
        if (index > 0) {
          result += ', ';
        }
        result += c.coseName;
      });
      return result;
    },
  },

  created() {
    this.$EventBus.$on('RevDateChanged', this.revDateChanged);
  },
  beforeDestroy() {
    this.$EventBus.$off('RevDateChanged', this.revDateChanged);
  },
  methods: {
    async revDateChanged(date) {
      this.selectedDate = date;

      try {
        let courseList = await reserveService.getDateCourseList(this.listType, date);
        if (courseList.resultCode !== '0000') {
          await this.showMsgBoxOkPmsErr(courseList.msg);
          // 에러 발생시 로딩 종료
          this.$EventBus.$emit('TeeOffLoadingEnd');
          return;
        }
        this.courseList = courseList.items;

        console.log('TYPE >>', this.listType);
        console.log('courseList', this.courseList);

        if (this.listType === 'REAL') {
          // 실시간접수
        } else {
          // 사전접수, 잔여/대기접수
          this.$EventBus.$emit('RevCourseChanged', {
            selectedDate: this.selectedDate,
            selectedCourse: this.selectedCourse === null ? this.courseList[0] : this.selectedCourse,
            totalCourse: this.courseList,
          });
        }
      } catch (error) {
        console.error('코스 정보 로드 중 에러:', error);
        this.$EventBus.$emit('TeeOffLoadingEnd');
      }
    },
  },
};
</script>

<style scoped lang="scss">
article {
  position: relative;
  width: 6rem;
  //width: 30%;
  height: 2.3rem;
  margin: 0.2rem;
  float: left;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
}

article div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  transition: 0.5s ease;
}

article input {
  position: absolute;
  top: 0;
  left: 0;
  width: 140px;
  height: 50px;
  opacity: 0;
}

input[type='radio']:checked ~ div {
  background-color: #50bcf2;
}
.mobile3 {
  display: none;
}
.web3 {
  margin: 0;
  padding: 0;
  .col {
    font-size: 0.9rem;
  }
  .row {
    font-size: 0.9rem;
  }
  .outterBox {
    width: 100%;

    .topHeader {
      display: flex;
      flex-direction: column;
      padding-top: 2rem;
      padding-left: 1rem;
      font-weight: bold;
      font-size: 1.3rem;
      .headerDetailText {
        font-size: 0.8rem;
        font-weight: 500;
        line-height: 1.3;
        color: #999999;
        margin-top: 0.3rem;
      }

      .subinfo {
        font-size: 0.7rem;
        font-weight: 500;
        line-height: 1.3;
        color: #727272;
        margin-top: 0.3rem;
      }
    }
    .top {
      display: flex;
      padding: 0rem;
      .dateColumn {
        width: 100%;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        margin-left: 1rem;
        margin-right: 1rem;
        background-color: white;
        display: inline-block;
      }
    }
  }
}
hr {
}
@media (max-width: 992px) {
  hr {
    margin: 0px;
  }
  .web3 {
    display: none;
    margin: 0;
    padding: 0;
  }
  .mobile3 {
    display: block;
    .col {
      font-size: 0.9rem;
    }
    .row {
      font-size: 0.9rem;
    }
    .outterBox {
      width: 100%;
      .topHeader {
        display: flex;
        flex-direction: column;
        padding-top: 2rem;
        padding-left: 1rem;
        font-weight: bold;
        font-size: 1.3rem;
        .subinfo {
          font-size: 0.7rem;
          font-weight: 500;
          line-height: 1.3;
          color: #727272;
          margin-top: 0.3rem;
        }
      }
      .top {
        display: flex;
        padding: 1rem;
        .dateColumn {
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          margin-left: 1rem;
          margin-right: 1rem;
          width: 100%;
          background-color: white;
          display: inline-block;
        }
      }
    }
  }
}
.rowSpace {
  height: 1rem;
}
.colSpace {
  width: 1rem;
}
</style>
